<template>
  <div>
    <basic-container>
      <avue-crud
        :option="tableOption"
        :data="tableData"
        :table-loading="tableLoading"
        :page="page"
        ref="crud"
        @search-change="searchChange"
        @refresh-change="refreshChange(page)"
        @row-save="handleSave"
        @row-update="handleUpdate"
        @selection-change="handleSelectionChange"
        @size-change="pageSizeChange"
        @current-change="pageChange"
      >
        <template slot-scope="scope" slot="menu">
          <el-button
            type="primary"
            icon="el-icon-check"
            size="small"
            plain
            @click.stop="openRecharge(scope.row,scope.index)"
          >充值</el-button>
        </template>
      </avue-crud>
      <!-- <el-dialog
        title="充值"
        :visible.sync="rechargeDialog"
        width="50%"
        style="background-color: #4E5465;"
      >
        <div style="margin-left:300px">
          <el-row :gutter="20" style="margin:10px;display:flex">
            请输入充值金额:
            <el-input v-model="rechargeObj.money" style="width:200px;height:60px;margin-left:60px"></el-input>
          </el-row>
          <el-row :gutter="20" style="margin: 10px;width: 50%;">
            请选择支付方式:
            <el-radio style="margin-left:60px">微信支付</el-radio>
          </el-row>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="rechargeDialog = false">取 消</el-button>
          <el-button type="primary" @click="immediateRecharge()">立即充值</el-button>
        </span>
      </el-dialog>-->
      <template>
        <el-dialog
          title="二维码支付"
          :visible.sync="QRCodeDialog"
          :before-close="closeQRCodeDialog"
          align="center"
        >
          <vue-qr :text="config.value" :size="200"></vue-qr>
          <el-row>二维码只会展示2分钟，请及时支付</el-row>
          <el-button @click="closeQRCodeDialog">关闭</el-button>
        </el-dialog>
      </template>
      <el-dialog
        title="提现"
        :visible.sync="cashAdvanceDialog"
        width="50%"
        style="background-color: #4E5465;"
      >
        <div style="margin-left:300px">
          <el-row :gutter="20" style="margin:10px;display:flex">
            请输入提现金额:
            <el-input
              v-model="cashAdvance.money"
              style="width:180px;height:60px;margin-left:60px"
              @blur="validationAmount()"
            ></el-input>
          </el-row>
          <el-row
            :gutter="20"
            style="margin:10px;width:60%;display:flex;justify-content: space-around"
          >
            <div style="width:160px;margin-right:60px">提现至银行卡:</div>
            <el-select v-model="bankCard" placeholder="请选择银行" required value-key="id">
              <el-option
                v-for="bankCard in bankCardList"
                :key="bankCard.id"
                :label="bankCard.name"
                :value="bankCard"
              ></el-option>
            </el-select>

            <!--<el-radio style="margin-left:60px">微信支付</el-radio>-->
          </el-row>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="cashAdvanceDialog = false">取 消</el-button>
          <el-button type="primary" :disabled="disabled" @click="cashWithdrawal()">提现</el-button>
        </span>
      </el-dialog>
      <template>
        <el-dialog :visible.sync="rechargeDialog" title="充值" center width="1000px">
          <div
            class="remittance"
            style="font-size: 14px;display: flex;flex-flow: column nowrap; align-items: flex-start;margin-left:205px"
          >
            <div class="recharge">
              <span
                style="width:130px;text-align:left;"
              >请输入充值积分:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
              <el-input
                type="number"
                placeholder="请输入充值积分"
                v-model="rechargeIntegral"
                style="width:215px"
              ></el-input>
            </div>
            <div style="display: flex;justify-content:flex-start;">
              <span style="width:130px;text-align:left;">支付方式:</span>
              <div>
                <el-radio
                  v-model="payRadio"
                  label="OFFLINE_REMIT"
                  @change="rechargeWayOFFLINE_REMIT"
                >线下汇款</el-radio>
                <!-- <el-radio v-model="payRadio" label="WX_PAY" @change="rechargeWayWX_PAY">微信支付</el-radio> -->
              </div>
            </div>
            <div class="recharge" v-if="this.payRadio == 'OFFLINE_REMIT'">
              <span
                style="width:130px;text-align:left;"
              >汇款账户名称:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
              <el-input
                type="text"
                placeholder="请输入汇款账户名称"
                v-model="remittanceAccountName"
                style="width:215px"
              ></el-input>
              <i
                style="font-style:normal;display: inline;font-size: 12px;color:red"
              >&nbsp;&nbsp;个人储蓄卡请填写持卡人姓名，对公账户请填写账户名称</i>
            </div>
            <div class="recharge" v-if="this.payRadio == 'OFFLINE_REMIT'">
              <span
                style="width:130px;text-align:left;"
              >汇款账户:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
              <el-input
                type="text"
                placeholder="请输入汇款账户"
                v-model="remittanceAccount"
                style="width:215px"
              ></el-input>
            </div>
            <div
              class="recharge"
              v-if="this.payRadio == 'OFFLINE_REMIT'"
              style="display: flex;justify-content:flex-start;"
            >
              <span style="width:130px;text-align:left;">汇款银行:</span>
              <div>
                <el-select placeholder="请输入汇款银行" v-model="currBank" style="width:215px">
                  <el-option
                    v-for="item in remittanceBank"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </div>
            </div>
            <div
              class="recharge"
              v-if="this.payRadio == 'OFFLINE_REMIT'"
              style=" margin-bottom:40px "
            >
              <span style="width:130px;text-align:left; ">凭证:</span>
              <el-upload
                :multiple="true"
                action="#"
                accept="image/jpeg, image/gif, image/png, image/bmp"
                :file-list="fileList1"
                :http-request="fnUploadremittanceImgs"
                :show-file-list="false"
              >
                <div v-if="'' != remittanceImgs" class="el-upload el-upload--picture-img">
                  <img
                    v-for="remittanceImg of remittanceImgs"
                    :key="remittanceImg.value"
                    :src="remittanceImg"
                    style="width: 200px;"
                  />
                </div>
                <div v-else class="el-upload el-upload--car-two">
                  <i class="el-icon-plus"></i>
                </div>
                <div class="el-upload__tip">请上传汇款回单凭证，只能上传jpg/png图片，且不超过500kb</div>
              </el-upload>
            </div>
            <div class="recharge" v-if="this.payRadio == 'OFFLINE_REMIT'">
              <span style="width:130px;text-align:left;">账户名称:</span>
              成都聚家科技有限公司
            </div>
            <div class="recharge" v-if="this.payRadio == 'OFFLINE_REMIT'">
              <span style="width:130px;text-align:left;">账户号码:</span>
              4402209109100103208
            </div>
            <div class="recharge" v-if="this.payRadio == 'OFFLINE_REMIT'">
              <span style="width:130px;text-align:left;">开户银行:</span>
              中国工商银行股份有限公司成都天顺路支行
            </div>
            <div class="recharge" v-if="this.payRadio == 'OFFLINE_REMIT'">
              <span style="width:130px;text-align:left;">汇款提示:</span>
              请避免北京时间18：00-00：00进行汇款，否则受银行出账时间影响，可能出现延迟一天到账情况。
            </div>
          </div>
          <div class="remittanceButton">
            <el-button
              round
              size="mini"
              @click="balancePayment"
            >&nbsp;&nbsp;&nbsp;立即充值&nbsp;&nbsp;&nbsp;</el-button>
            <el-button
              round
              type="danger"
              size="mini"
              @click="rechargeDialog = false"
            >&nbsp;&nbsp;&nbsp;取消&nbsp;&nbsp;&nbsp;</el-button>
          </div>
        </el-dialog>
      </template>
      <template>
        <el-dialog title="二维码支付" :visible.sync="QRCodeDialog" align="center">
          <vue-qr :text="config.value" :size="200"></vue-qr>
          <el-row>二维码只会展示2分钟，请及时支付</el-row>
          <el-button @click="QRCodeDialog = false">关闭</el-button>
        </el-dialog>
      </template>
    </basic-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { integralBalanceOption } from "@/const/salesCloud/integralBalanceOption";
import {
  findBalance,
  addBalance,
  findCashLimitation,
  findAccountBalance,
  cashWithdrawal
} from "@/api/salesCloud/integralBalance";
import { wxNativePayQuery } from "@/api/salesCloud/depositRecharge";
import { findBankCard } from "@/api/salesCloud/bank";
import { findByLabel } from "@/util/util";
import { DIC } from "@/const/dic";
import { getAliyunPublicToken } from "@/api/oss/aliyun";
import VueQr from "vue-qr";
import oss from "ali-oss";
import md5 from "js-md5";

export default {
  name: "integralBalance",
  components: {
    VueQr
  },
  data() {
    return {
      tableOption: integralBalanceOption, //表格设置属性
      tableData: [], //表格的数据
      tablePage: 1,
      tableLoading: false,
      tabelObj: {},
      rechargeIntegral: "",
      paymentTask: {},
      payRadio: "OFFLINE_REMIT",
      remittanceAccountName: "",
      remittanceAccount: "",
      currBank: "",
      remittanceBank: DIC.BANK_LIST,
      QRCodeDialog: false,
      fileList1: [],
      remittanceImgs: [],
      page: {
        total: 0, //总页数
        currentPage: 1, //当前页数
        pageSize: 10 //每页显示多少条
      },
      grade: {
        box: false,
        check: []
      },
      rechargeDialog: false,
      rechargeObj: {},
      // QRCodeDialog: false,
      config: {},
      cashLimit: {},
      cashAdvanceDialog: false,
      cashAdvance: {},
      bankCardList: [],
      bankCard: {},
      disabled: false,
      balance: 0,
      count: 0
    };
  },
  created() {
    findCashLimitation().then(res => {
      let data = JSON.parse(res.data);
      this.cashLimit = data;
    });
    findBankCard().then(res => {
      let data = JSON.parse(res.data);
      this.bankCardList = data;
      // if(this.bankCardList.length>=1){
      //     this.bankCard= this.bankCardList[0]
      // }
    });
    findAccountBalance().then(res => {
      let data = JSON.parse(res.data);
      this.balance = data.balance;
    });
    this.handleList();
  },
  watch: {},
  mounted() {},
  computed: {
    ...mapGetters(["permission"])
  },
  props: [],
  methods: {
    clean() {
      this.describeImgs = [];
      this.remittanceImgs = [];
      this.rechargeIntegral = "";
      this.paymentTask = {};
      this.remittanceAccountName = "";
      this.remittanceAccount = "";
      this.currBank = "";
    },
    balancePayment() {
      let params = {};
      params.integral = this.rechargeIntegral;
      //params.rechargeType = "BALANCE";
      params.payType = this.payRadio;
      params.openingUser = this.remittanceAccountName;
      params.bankNumber = this.remittanceAccount;
      params.bankName = this.currBank;
      params.url = this.remittanceImgs + "";
      if (params.payType == "OFFLINE_REMIT") {
        if (
          params.integral &&
          params.openingUser &&
          params.bankNumber &&
          params.bankName &&
          params.url
        ) {
          if(params.integral<=0){
            this.$message({
            showClose: true,
            message: "积分不能小于等于0",
            type: "error"
          });
          return;
          }
          addBalance(params).then(res => {
            if (res.code == "200") {
              this.$message({
                showClose: true,
                message:
                  "非常感谢您对慧家平台的信任，请耐心等待平台财务人员核实。",
                type: "success"
              });
              this.rechargeDialog = false;
              this.payMoneyDialog = false;
              setTimeout(() => {
                this.$router.push({ path: "/salesCloud/manualIntegral" });
              }, 5000);
            } else {
              this.$message({
                showClose: true,
                message: res.message,
                type: "error"
              });
            }
          });
        } else {
          this.$message({
            showClose: true,
            message: "请完善输入信息",
            type: "error"
          });
        }
      } else {
        addBalance(params).then(response => {
          this.tableLoading = false;
          if (response.code == "200") {
            let data = response.data;
            let count = 0;
            wxNativePayQuery(data.outTradeNo).then(res => {
              if (res.code == "200") {
                if (res.data == "SUCCESS") {
                  let _this = this;
                  setTimeout(function() {
                    _this.QRCodeDialog = false;
                    _this.$message({
                      showClose: true,
                      message: "支付成功",
                      type: "success"
                    });
                    _this.handleList();
                    _this.payMoneyDialog = false;
                    _this.rechargeDialog = false;
                    _this.$router.push({ name: "账号明细管理" });
                  }, 1000);
                } else {
                  count++;
                  if (count < 3) {
                    wxNativePayQuery(data.outTradeNo).then(res => {
                      if (res.code == "200") {
                        if (res.data == "SUCCESS") {
                          let _this = this;
                          setTimeout(function() {
                            _this.QRCodeDialog = false;
                            _this.$message({
                              showClose: true,
                              message: "支付成功",
                              type: "success"
                            });
                            _this.handleList();
                            _this.payMoneyDialog = false;
                            _this.rechargeDialog = false;
                            _this.$router.push({ name: "账号明细管理" });
                          }, 1000);
                        } else {
                          this.QRCodeDialog = false;
                          this.$message({
                            showClose: true,
                            message: "支付超时",
                            type: "error"
                          });
                        }
                      } else {
                        this.QRCodeDialog = false;
                        this.$message({
                          showClose: true,
                          message: "支付超时",
                          type: "error"
                        });
                      }
                    });
                  }
                }
                //this.handleList();
              } else {
                this.QRCodeDialog = false;
                this.$message({
                  showClose: true,
                  message: "支付超时",
                  type: "error"
                });
                this.handleList();
              }
            });
            let start = new Date().getTime();
            while (true) if (new Date().getTime() - start > 1) break;
            this.config.value = "";
            this.config.value = data.codeUrl;
            this.QRCodeDialog = true;
          } else {
            this.$message({
              showClose: true,
              message: "支付失败" + response.message,
              type: "error"
            });
            //???下面的感觉没用
            // this.$refs.crud.rowAdd();
            return;
          }
          // let data = JSON.parse(res.data);
        });
      }
    },
    rechargeWayBALANCE() {
      this.paymentTask.rechargeWay = "BALANCE";
    },
    rechargeWayWX_PAY() {
      this.paymentTask.rechargeWay = "WX_PAY";
    },
    rechargeWayOFFLINE_REMIT() {
      this.paymentTask.rechargeWay = "OFFLINE_REMIT";
    },
    pageSizeChange(pageSize) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      (params.page = this.page.currentPage), (params.size = pageSize);
      findBalance(params).then(res => {
        let data = JSON.parse(res.data);
        let balance=data.balance;
        if(balance==null){
          balance=0
        }
        let rows=[];
        let rowsData={};
        rowsData.balance=balance;
        rows.push(rowsData);
        this.tableData = rows;
        this.page = {
          total: 1,
          currentPage: this.page.currentPage,
          pageSize: pageSize
        };
        this.tableLoading = false;
      });
    },
    pageChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page;
      params.size = this.page.pageSize;
      findBalance(params).then(res => {
        let data = JSON.parse(res.data);
        let balance=data.balance;
        if(balance==null){
          balance=0
        }
        let rows=[];
        let rowsData={};
        rowsData.balance=balance;
        rows.push(rowsData);
        this.tableData = rows;
        this.page = {
          total: 1,
          currentPage: page,
          pageSize: this.page.pageSize
        };
        this.tableLoading = false;
      });
    },
    searchChange(params) {
      this.tableLoading = true;
      // let params = this.$refs.crud.searchForm
      params.page = this.page.currentPage;
      params.size = this.page.pageSize;

      console.log(params.startDate_endDate);
      findBalance(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: params.page,
          pageSize: params.size
        };
        this.tableLoading = false;
      });
    },
    refreshChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page.currentPage;
      params.size = page.pageSize;
      findBalance(params).then(res => {
        let data = JSON.parse(res.data);
        let balance=data.balance;
        if(balance==null){
          balance=0
        }
        let rows=[];
        let rowsData={};
        rowsData.balance=balance;
        rows.push(rowsData);
        this.tableData = rows;
        this.page = {
          total: 1,
          currentPage: page.currentPage,
          pageSize: page.pageSize
        };
        this.tableLoading = false;
      });
    },
    /**
     * @title 打开新增窗口
     * @detail 调用crud的handleadd方法即可
     *
     **/
    handleAdd() {
      // this.clean()
      this.$refs.crud.rowAdd();
    },
    handleEdit(row, index) {
      // this.clean()
      // this.clientType = this.formatClientType(row.useCustomerType)
      // this.joinsWorkServiceCategory = {id: row.serviceCategoryId}
      // this.choseWorkServiceItem();
      // this.joinsWorkServiceItem = {id: row.serviceItemId}
      // if (row.startTime != null && row.endTime != null) {
      //     let array = []
      //     array.push(row.startTime)
      //     array.push(row.endTime)
      //     row.startTime_endTime = array
      // }
      this.$refs.crud.rowEdit(row, index);
    },
    /**
     * @title 获取数据
     * @detail 赋值为tableData表格即可
     *
     **/
    handleList() {
      this.tableLoading = true;
      let parmas = {
        page: this.page.currentPage,
        size: this.page.pageSize
      };
      findBalance(parmas).then(res => {
        let data = JSON.parse(res.data);
        let balance=data.balance;
        if(balance==null){
          balance=0
        }
        let rows=[];
        let rowsData={};
        rowsData.balance=balance;
        rows.push(rowsData);
        this.tableData = rows;
        this.page = {
          total: 1,
          currentPage: this.page.currentPage,
          pageSize: this.page.pageSize
        };
        this.tableLoading = false;
      });
    },
    /**
     * @title 数据添加
     * @param row 为当前的数据
     * @param done 为表单关闭函数
     *
     **/
    handleSave(row, done) {},
    /**
     * @title 当前选中的数据
     * @param val 选中的值
     *
     **/
    handleSelectionChange() {
      // console.log(val);
      // this.tableRow = val;
      // this.$notify({
      //     showClose: true,
      //     message: JSON.stringify(val),
      //     type: 'success',
      // });
    },
    /**
     * @title 数据删除
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     *
     **/
    handleDel(dicName, label) {},
    /**
     * @title 数据更新
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     * @param done 为表单关闭函数
     *
     **/
    handleUpdate(row, index, done) {},
    openRecharge() {
      this.rechargeDialog = true;
      this.clean();
    },
    getWeek(date) {
      let week;
      if (date == 0) week = "星期天";
      if (date == 1) week = "星期一";
      if (date == 2) week = "星期二";
      if (date == 3) week = "星期三";
      if (date == 4) week = "星期四";
      if (date == 5) week = "星期五";
      if (date == 6) week = "星期六";
      return week;
    },
    openCashAdvanceDialog() {
      let txt = "";
      let time = new Date(this.cashLimit.sysTime);
      let weeks = this.cashLimit.week.split(",");
      let flag = false;
      for (let i = 0; i < weeks.length; i++) {
        if (weeks[i] == "7") {
          weeks[i] = "0";
        }
        if (weeks[i] == time.getDay()) {
          flag = true;
          break;
        }
        let week = this.getWeek(weeks[i]);
        txt += week + ",";
      }
      txt = txt.substring(0, txt.length - 1);
      txt = "可提现日期为：" + txt;
      if (flag) {
        this.cashAdvanceDialog = true;
      } else {
        this.$message({
          showClose: true,
          message: txt,
          type: "error"
        });
      }

      //this.cashAdvanceDialog=true
    },
    immediateRecharge() {
      addBalance(this.rechargeObj).then(response => {
        this.tableLoading = false;
        if (response.code == "200") {
          let data = response.data;
          this.count = 0;
          this.wxNativePayQuery(data.outTradeNo);
          // wxNativePayQuery(data.outTradeNo).then((res) => {
          //     console.log(res)
          //     if (res.code == '200') {
          //         if(res.data=='SUCCESS'){
          //             let _this=this;
          //             setTimeout(function () {
          //                 _this.QRCodeDialog = false
          //                 _this.$message({
          //                     showClose: true,
          //                     message: "充值成功",
          //                     type: "success"
          //                 })
          //                 _this.handleList();
          //             }, 500);
          //         }else{
          //             this.QRCodeDialog = false
          //             this.$message({
          //                 showClose: true,
          //                 message: "支付超时",
          //                 type: "error"
          //             })
          //         }
          //         //this.handleList();
          //     }else{
          //         this.QRCodeDialog = false
          //         this.$message({
          //             showClose: true,
          //             message: "支付超时",
          //             type: "error"
          //         })
          //         this.handleList();
          //     }
          // })
          let start = new Date().getTime();
          while (true) if (new Date().getTime() - start > 1) break;
          this.config.value = "";
          this.rechargeDialog = false;
          this.config.value = data.codeUrl;
          this.QRCodeDialog = true;
          //this.$router.push({ name: "支付页面", path: "/salesCloud/payPage/pay" ,query:{}});
          // loading.close();
        } else {
          this.$message({
            showClose: true,
            message: response.message,
            type: "error"
          });
          done();
          this.$refs.crud.rowAdd();
          return;
        }
      });
    },
    closeQRCodeDialog() {
      this.QRCodeDialog = false;
      this.handleList();
      location.reload();
    },
    wxNativePayQuery(outTradeNo) {
      wxNativePayQuery(outTradeNo).then(res => {
        if (res.code == "200") {
          if (res.data == "SUCCESS") {
            let _this = this;
            setTimeout(function() {
              _this.QRCodeDialog = false;
              _this.$message({
                showClose: true,
                message: "充值成功",
                type: "success"
              });
              _this.handleList();
            }, 500);
          } else {
            this.count++;
            if (this.count < 5) {
              this.wxNativePayQuery(outTradeNo);
            } else {
              this.QRCodeDialog = false;
              this.$message({
                showClose: true,
                message: "支付超时",
                type: "error"
              });
            }
          }
          //this.handleList();
        } else {
          this.QRCodeDialog = false;
          this.$message({
            showClose: true,
            message: "支付超时",
            type: "error"
          });
          this.handleList();
        }
      });
    },
    validationAmount() {
      let flag = true;
      let txt = "不符合提现规则";
      if (this.balance < this.cashAdvance.money * 1) {
        this.disabled = true;
        txt = "提现金额不能大于余额";
        flag = false;
      } else {
        this.disabled = false;
      }
      if (flag) {
        if (this.cashLimit.minAmount > this.cashAdvance.money) {
          this.disabled = true;
        } else {
          this.disabled = false;
        }
        if (this.cashAdvance.money % this.cashLimit.minAmount == 0) {
          this.disabled = false;
        } else {
          this.disabled = true;
        }
      }

      //this.cashAdvance.money
      if (this.disabled) {
        this.$message({
          showClose: true,
          message: txt,
          type: "error"
        });
      }
    },
    cashWithdrawal() {
      if (typeof this.cashAdvance.money == "undefined") {
        this.$message({
          showClose: true,
          message: "请填写提现金额",
          type: "error"
        });
        return;
      }
      this.validationAmount();
      this.cashAdvance.bankId = this.bankCard.id;
      this.cashAdvance.depositType='BANK';
      cashWithdrawal(this.cashAdvance).then(res => {
        if (res.code == "200") {
          this.$message({
            showClose: true,
            message: "提现成功",
            type: "success"
          });
          this.cashAdvanceDialog = false;
          this.cashAdvance={};
          this.bankCard={};
          this.handleList();
        } else {
          this.$message({
            showClose: true,
            message: res.message,
            type: "error"
          });
        }
      });
    },
    async fnUploadremittanceImgs(option) {
      this.tableLoading = true;
      getAliyunPublicToken().then(res => {
        let data = JSON.parse(res.data);
        let client = new oss({
          region: data.point,
          endPoint: data.point,
          accessKeyId: data.accessKeyId,
          accessKeySecret: data.accessKeySecret,
          Expiration: data.expiration,
          bucket: data.bucketName,
          stsToken: data.securityToken
        });
        const storeAs = md5(option.file.name) + new Date().getTime();
        client
          .multipartUpload(storeAs, option.file, {})
          .then(results => {
            let res = results.res.requestUrls;
            let files = new Array();
            for (let url in res) {
              let file = new Object();
              file.label = storeAs;
              file.value = url;
              files.push(file);
            }
            this.fileList1 = files;
            let array = results.res.requestUrls[0].split("?");
            this.remittanceImgs.push(array[0]);
            this.tableLoading = false;
          })
          .catch(err => {
            console.log(err);
          });
      });
    }
  }
};
</script>

<style lang="scss">
.remittanceButton {
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  margin-top: 30px;
}
.table-container {
  padding: 8px 10px;
}

.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
.remittance {
  .recharge {
    margin-top: 10px;
  }
}
</style>
